<adapt-dialog [maxWidth]="600"
              [fitHeight]="true"
              [showCancelButtonOnTitle]="true"
              [showHelpButton]="false">
    <h3 adapt-dialog-title>AI actions</h3>

    <div adapt-dialog-content
         class="d-flex flex-column gap-3 h-100">
        <div class="d-flex flex-column gap-1">
            <label>Original text
                <button [adaptButton]="collapseOriginalText ? 'expandBorderless' : 'collapseBorderless'"
                        class="original-text-button"
                        (click)="collapseOriginalText = !collapseOriginalText"></button>
            </label>
            <div class="original-text-container"
                 [collapse]="collapseOriginalText">
                <dx-scroll-view>
                    <div [froalaView]="data.text"
                         class="original-text"></div>
                </dx-scroll-view>
            </div>
        </div>
        <div class="d-flex gap-2 flex-wrap">
            <div class="command-section">
                <label>Action</label>
                <dx-select-box displayExpr="displayText"
                               valueExpr="type"
                               [disabled]="isLoading"
                               [dataSource]="actions"
                               [value]="selectedAction.type"
                               (onValueChanged)="onActionChange($event)"></dx-select-box>
            </div>

            @for (param of commandParams; track param[0]) {
                @let paramKey = param[0];
            @let paramDetail = param[1];

            <div [ngClass]="{
                    'prompt-section': isTextAreaEdit(paramDetail),
                    'command-section': isSelectEdit(paramDetail),
                }">
                <label>{{ paramDetail.label }}</label>
                @if (isSelectEdit(paramDetail)) {
                    <dx-select-box displayExpr="text"
                                   valueExpr="value"
                                   [disabled]="isLoading"
                                   [dataSource]="paramDetail.selectValues"
                                   [(value)]="params[paramKey]"
                                   (onValueChanged)="onParamChange($event)"
                                   [showClearButton]="paramDetail.selectOptional"> </dx-select-box>
                }
                @if (isTextAreaEdit(paramDetail)) {
                    <dx-text-area [disabled]="isLoading"
                                  [(value)]="$any(params[paramKey])"> </dx-text-area>
                }
        </div>
    }

    <button class="btn btn-link ms-2 mt-auto regen-button"
            [adaptButtonIcon]="isLoading ? 'fal fa-spin fa-sync-alt' : 'refresh'"
            (click)="load()"
            [disabled]="isLoading || !parametersAreSet">
        {{ isLoading ? "Generating..." : resultText ? "Regenerate" : "Generate" }}
    </button>
    </div>

    <div class="d-flex flex-column gap-1 proposed-text">
        <label>Proposed text</label>
        <adapt-html-editor [(contents)]="resultText"
                           [readonly]="true"
                           [onlyShowToolbarWhenFocussed]="true"
                           [minHeight]="200"
                           [class.opacity-75]="isLoading"
                           placeholderText=""></adapt-html-editor>
    </div>
    </div>

    <div adapt-dialog-footer
         class="d-flex flex-grow-1 gap-2">
        <button type="button"
                class="ms-auto btn btn-outline-primary border border-primary"
                [disabled]="isLoading || !resultText"
                [adaptTooltip]="copiedText ? 'Copied' : 'Copy to clipboard'"
                [adaptButtonIcon]="'fal fa-fw ' + (copiedText ? 'fa-check' : 'fa-copy')"
                (click)="copyToClipboard(rawResultText)">
            {{ copiedText ? "Copied" : "Copy" }}
        </button>
        <button class="btn btn-primary"
                (click)="replace()"
                [disabled]="isLoading || !resultText">Replace</button>
        @if (isLoading) {
            <button class="btn btn-secondary"
                    (click)="interruptLoad()">Cancel</button>
        }
    </div>
</adapt-dialog>
